import React, { useEffect, useState } from "react";
import styles from "./onboarding.module.css";
import { Row, Button, Col } from "react-bootstrap";
import BeneficiaryDetail from "../../component/onboarding/beneficiary/beneficiary";
import Remitter from "../../component/onboarding/remitter/remitter";
import Student from "../../component/onboarding/studentDetails/student";
import NewHeader from "../NavBar/newHeader";
import Footer from "../../component/Footer/Footer.js";
import { useNavigate } from "react-router-dom";
import HeadWithSubHead from "../../common/HeadWithSubHead/index.js";
import { useMyContext } from "../../myContext.js";
import rightArrow from "../../public/assets/rightArrow.svg";
import Stepper from "../../component/Stepper/Stepper.js";
import { validateTransaction } from "../../api";

const OnBoard = () => {
  const navigate = useNavigate();
  const {
    setIsCompleted,
    completedRemitter,
    completedStudent,
    completedBeneficiary,
    isEducationLoanCheck,
    setIsEducationLoanCheck,
    remitterBankId,
    studentUserId,
    beneficiryBankId,
    stepToShow,
    setStepsToShow,
    isConfirmedCheck,
    setIsConfirmedCheck,
    userStatus,
    setUserStatus,
    remitterShortDetail,
    shortRemitterBankDetail,
    studentShortDetail,
    beneficiaryShortDetail,
    shortBeneficiaryBankDetail,
    themeColor,
    loadingLogo,
  } = useMyContext();
  const [formCompleted, setFormCompleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorFromValidate, setErrorFromValidate] = useState(false);
  const [accountDetail, setAccountDetail] = useState({
    remitterName: "",
    remitterBank: "",
    remitterAccount: "",
    studentName: "",
    beneficaryName: "",
    beneficiaryBank: "",
    beneficiaryAccount: "",
  });

  const onBoardingComplete = async () => {
    setLoading(true);

    const body = {
      studentId: studentUserId,
      bankId: remitterBankId,
    };

    try {
      const response = await validateTransaction(body);

      if (response && response.status === 200) {
        sessionStorage.setItem("remitterBankId", remitterBankId);
        sessionStorage.setItem("referenceId", response?.data?.referenceId);
        sessionStorage.setItem("studentId", studentUserId);
        sessionStorage.setItem("beneficiaryBankId", beneficiryBankId);
        let accountDetailString = JSON.stringify(accountDetail);
        sessionStorage.setItem("accountDetail", accountDetailString);
        sessionStorage.setItem("EducationLoan", isEducationLoanCheck);
        sessionStorage.setItem("nextStep", "quote");
        setIsCompleted(true);
        setUserStatus("quote");
        navigate("/quote");
      } else {
        setErrorFromValidate(response.data.message);
      }
    } catch (error) {
      console.error("Error validating transaction:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setAccountDetail((prevState) => ({
      ...prevState,
      remitterName: remitterShortDetail.name,
      remitterBank: shortRemitterBankDetail.bankName,
      remitterAccount: shortRemitterBankDetail.accountMasked,
      studentName: studentShortDetail.name,
      beneficaryName: beneficiaryShortDetail.name,
      beneficiaryBank: shortBeneficiaryBankDetail.bankName,
      beneficiaryAccount: shortBeneficiaryBankDetail.accountMasked,
    }));
  }, [
    remitterShortDetail,
    shortRemitterBankDetail,
    studentShortDetail,
    beneficiaryShortDetail,
    shortBeneficiaryBankDetail,
  ]);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   if (userStatus === "quote-generated" || userStatus === null) {
  //     navigate("/transaction-detail", { replace: true });
  //     window.location.reload();
  //   }
  //   setIsCompleted(false);
  // }, []);

  useEffect(() => {
    if (
      completedStudent &&
      completedRemitter &&
      completedBeneficiary &&
      isConfirmedCheck
    ) {
      setFormCompleted(true);
    } else {
      setFormCompleted(false);
    }
  }, [
    completedRemitter,
    completedStudent,
    completedBeneficiary,
    isConfirmedCheck,
  ]);
  return (
    <>
      <NewHeader show={true} />
      <Stepper stepPercent={50} />
      <div className={`container ${styles.mainContainer}`}>
        <Row>
          <HeadWithSubHead
            head="Account Setup"
            subHead="Just a few steps away. This should take less than 10 mins."
          />
        </Row>
        <Row style={{ marginTop: "40px" }}>
          <>
            <Remitter stepToShow={stepToShow} setStepsToShow={setStepsToShow} />
            <Student
              stepToShow={stepToShow}
              setStepsToShow={setStepsToShow}
              accountDetail={accountDetail}
            />
            <BeneficiaryDetail
              stepToShow={stepToShow}
              setStepsToShow={setStepsToShow}
              accountDetail={accountDetail}
            />
          </>
        </Row>
        {errorFromValidate && (
          <Row>
            <div className={styles.errorState}>{errorFromValidate}</div>
          </Row>
        )}
        <Row className={styles.legalBox} style={{ border: "0px" }}>
          <div class="form-check" className={styles.checkMark}>
            <input
              class="form-check-input"
              className={styles.checkbox}
              type="checkbox"
              id="flexCheckDefault"
              checked={isEducationLoanCheck}
              onChange={() => {
                setIsEducationLoanCheck(!isEducationLoanCheck);
              }}
            />
            <label
              class="form-check-label"
              className={styles.checklabel}
              for="flexCheckDefault"
            >
              The following remittance is via an Education Loan.
            </label>
          </div>
        </Row>
        <Row className={styles.legalBox} style={{ border: "0px" }}>
          <div class="form-check" className={styles.checkMark}>
            <input
              class="form-check-input"
              className={styles.checkbox}
              type="checkbox"
              id="flexCheckChecked"
              checked={isConfirmedCheck}
              onChange={() => {
                setIsConfirmedCheck(!isConfirmedCheck);
              }}
            />
            <label
              class="form-check-label"
              className={styles.checklabel}
              for="flexCheckChecked"
            >
              I confirm all the details listed above are correct and exact for
              the following remittance. Also, the bank account to be used for
              the remittance belongs to Remitter ONLY.
            </label>
          </div>
        </Row>
        <Row style={{ paddingTop: "20px" }}>
          {loadingLogo ? (
            <Col style={{ padding: "0px" }}>
              <Button
                className={`${styles.generateButton} ${
                  formCompleted && !loading ? "" : styles.disabledButton
                }`}
                disabled={!formCompleted || loading}
                style={{
                  cursor: !formCompleted || loading ? "not-allowed" : "pointer",
                  background: themeColor,
                }}
                onClick={() => onBoardingComplete()}
              >
                {loading ? "Validating..." : "Proceed"}
                {!loading && (
                  <img
                    className={styles.rightArrow}
                    style={{ marginLeft: "6px" }}
                    src={rightArrow}
                    alt=""
                  />
                )}
              </Button>
            </Col>
          ) : (
            ""
          )}
        </Row>
      </div>
      <Footer />
    </>
  );
};

export default OnBoard;
